// Access-denied page for the IAS deployment. `AppSsoProvider` pushes users
// here when the OIDC exchange comes back 403 (`InsightsApplicationAccess`
// permission missing). Ports the ias-master look — `error_cat.svg`,
// application-appropriate copy, and a link back to the amelia Launcher.

import { t } from "ttag";

import { EmptyState } from "metabase/common/components/EmptyState";
import { Box } from "metabase/ui";

import S from "./IasAccessDenied.module.css";
import { getConfigSettings } from "./configs";

export const IasAccessDenied = (): JSX.Element => {
  // `ssoApiBaseUrl` points at the amelia API host; the human-facing launcher
  // lives at the corresponding non-`api` subdomain in every environment.
  const { ssoApiBaseUrl } = getConfigSettings();
  const launcherUrl = ssoApiBaseUrl?.replace("api.", "") || "#";

  return (
    <Box className={S.root}>
      <img src="/app/assets/img/error_cat.svg" alt="" className={S.errorCat} />
      <EmptyState
        title={t`Access Denied`}
        message={t`It looks like your account doesn't have the required permissions to open this application. Please contact your administrator if you believe this is a mistake.`}
        action={t`Return to amelia Launcher`}
        link={launcherUrl}
      />
    </Box>
  );
};
